import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";

/**
 * R6 — Small dropdown modal for row actions.
 * Used by RowContextMenu for Edit Source and Assign Rep.
 * The Status action reuses the existing status popup in LeadTable.
 */
export default function RowActionPrompt({
  open,
  title,
  options,
  value,
  onSave,
  onClose,
  saving = false,
}) {
  const [selected, setSelected] = useState(value || "");

  useEffect(() => {
    if (open) setSelected(value || "");
  }, [open, value]);

  if (!open) return null;

  return createPortal(
    <div
      className="modal-overlay"
      role="presentation"
      onMouseDown={() => !saving && onClose?.()}
    >
      <div
        className="modal r6-row-prompt"
        role="dialog"
        aria-modal="true"
        aria-label={title}
        onMouseDown={(e) => e.stopPropagation()}
        style={{ maxWidth: 420 }}
      >
        <div className="modal-header">
          <h3>{title}</h3>
          <button
            type="button"
            className="btn btn-ghost btn-sm"
            onClick={onClose}
            disabled={saving}
            aria-label="Close"
          >
            <i className="fas fa-times" />
          </button>
        </div>

        <div className="modal-body">
          <div className="form-group">
            <label>Select</label>
            <select
              className="form-control"
              value={selected}
              onChange={(e) => setSelected(e.target.value)}
              autoFocus
              disabled={saving}
            >
              <option value="">— Choose —</option>
              {options.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div
          className="modal-footer"
          style={{
            display: "flex",
            gap: 8,
            justifyContent: "flex-end",
            paddingTop: 12,
            borderTop: "1px solid rgba(10, 26, 74, 0.06)",
          }}
        >
          <button
            type="button"
            className="btn btn-secondary"
            onClick={onClose}
            disabled={saving}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => onSave?.(selected)}
            disabled={saving || !selected}
          >
            {saving ? (
              <>
                <i className="fas fa-spinner fa-spin" /> Saving…
              </>
            ) : (
              "Save"
            )}
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
}